(function() {
    const archiveEl = document.body.querySelector('.jsResearchArchive');
    let archiveGrid = null;
    let currentPage = 1;
    let searchTimeout = null;
    let searchQuery = '';
    let postType = 'rut_research';

    if (archiveEl) {
        postType = typeof archiveEl.dataset.postType !== 'undefined' ? archiveEl.dataset.postType : 'post';
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const targetGroupFilterEl = archiveEl.querySelector('.jsTargetGroupFilter');
        if (targetGroupFilterEl) {
            const targetGroupSelect = new SeSelect(targetGroupFilterEl, 'target-group');
            targetGroupSelect.setActiveOptions(activeTargetGroups);

            targetGroupSelect.addChangeEventListener(newOptions => {
                activeTargetGroups = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            const typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(newOptions => {
                activeTypes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            const searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        const url = new Url;

        if (searchQuery) url.query.search = searchQuery;
        else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(_ => updateGrid(), 500);
    }

    function updateGrid() {
        const params = {
            action: 'get_story_grid_html',
            searchQuery: searchQuery,
            pageNumber: currentPage,
            baseUrl: archiveUrl + window.location.search,
            postType: postType
        };

        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activeTargetGroups !== 'undefined') params.activeTargetGroups = activeTargetGroups;
        if (typeof activeTypes !== 'undefined') params.activeTypes = activeTypes;

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
